export const LABS_VIM_SPECIALTY_ID = 'f_149_0';
export const LABS_SPECIALTY_DESCRIPTION = 'Clinical Medical Laboratory';
